import graphql__7fe6d709b768b1fa15bf from "./__generated__/ParticipativeModuleResultsFormFieldMap_result.graphql.js";import { graphql, useFragment } from "react-relay";
import HighchartsReact from "highcharts-react-official";

import Highcharts from "../../lib/charts/customHighCharts";
import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import { mapChartConfig } from "../../lib/charts/mapChart";
import { useChartOptions } from "../../lib/charts/useChartColors";

// TODO : Fix the chart which doesn't work
const ParticipativeModuleResultsFormFieldMap = props => {
  const result = useFragment(ParticipativeModuleResultsFormFieldMap_result, props.result);

  const { colors, color, clusterLabel, resetZoomLabel } = result;

  const chartOptions = useChartOptions(colors);

  const chartConfig = {
    ...mapChartConfig(
      { locations: result.data },
      { color, clusterLabel, resetZoomLabel }
    ),
    ...chartOptions
  };

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <HighchartsReact highcharts={Highcharts} options={chartConfig} />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldMap_result = graphql__7fe6d709b768b1fa15bf;

export default ParticipativeModuleResultsFormFieldMap;
